import React from 'react';
import './index.scss';

const HighlightedSentence = ({ children }) => (
  <p className='highlight_sentence'>
    {children}
  </p>
);

export default HighlightedSentence;
